import { useState, useEffect } from 'react';
import axios from 'axios';

const useSeoData = (currentPath, fallbackTitle, fallbackDescription) => {
  // Initialize with fallback values
  const [seoData, setSeoData] = useState({
    title: fallbackTitle || 'Zahoot - UK Solicitors Directory',
    description: fallbackDescription || 'Find qualified solicitors and law firms in the UK'
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // If fallbacks change, update the state immediately
    setSeoData(prev => ({
      title: fallbackTitle || prev.title,
      description: fallbackDescription || prev.description
    }));
    
    const fetchSeoData = async () => {
      try {
        setIsLoading(true);
        setError(null);
        console.log('🔍 SEO Debug - Current path:', currentPath);
        console.log('🔍 SEO Debug - Fallback title:', fallbackTitle);
        console.log('🔍 SEO Debug - Fallback description:', fallbackDescription);
        
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/seo`);
        const entries = response.data;
        console.log('🔍 SEO Debug - All entries:', entries);
        
        // Find matching entry for current path
        const matchingEntry = entries.find(entry => {
          // Remove trailing slashes for comparison
          const cleanUrl = entry.url.replace(/\/$/, '');
          const cleanPath = currentPath.replace(/\/$/, '');
          console.log('🔍 SEO Debug - Comparing:', cleanUrl, 'vs', cleanPath);
          return cleanUrl === cleanPath;
        });

        if (matchingEntry) {
          console.log('🔍 SEO Debug - Found matching entry:', matchingEntry);
          setSeoData({
            title: matchingEntry.seo_title,
            description: matchingEntry.seo_description
          });
        } else {
          console.log('🔍 SEO Debug - No matching entry, using fallbacks');
          // Use fallback values if no matching entry found
          setSeoData({
            title: fallbackTitle || 'Zahoot - UK Solicitors Directory',
            description: fallbackDescription || 'Find qualified solicitors and law firms in the UK'
          });
        }
      } catch (error) {
        console.error('Error fetching SEO data:', error);
        setError(error);
        // Set fallback values on error
        setSeoData({
          title: fallbackTitle || 'Zahoot - UK Solicitors Directory',
          description: fallbackDescription || 'Find qualified solicitors and law firms in the UK'
        });
      } finally {
        setIsLoading(false);
      }
    };

    // Only fetch if we have a current path
    if (currentPath) {
      fetchSeoData();
    } else {
      setIsLoading(false);
    }
  }, [currentPath, fallbackTitle, fallbackDescription]);

  console.log('🔍 SEO Debug - Final seoData:', seoData);
  return { seoData, isLoading, error };
};

export default useSeoData; 